module.exports = __webpack_public_path__ + "img/ngo.4905d0d8.png";